import { combineReducers } from 'redux'

import application from './application'
import simulate from './simulate'
import utmTracking from './utm'
import map from './map'
import gym from './gym'
import address from './address'
import country from './country'

const rootReducer = combineReducers({
  application,
  simulate,
  utmTracking,
  map,
  gym,
  address,
  country,
})

export default rootReducer
